<template>
	<div class="slide-house">
		<div class="slide-1">
			<img src="/themes/rise-theme/dist/images/estate/character-view/henry/01_house_full.png" alt="">
		</div>

		<div class="slide-2">
			<img v-parallax-fit="slideOne" class="slide-left"
				src="/themes/rise-theme/dist/images/estate/character-view/henry/01_house_left.png" alt="">
			<img v-parallax-fit="slideTwo" ref="slideTwo" class="slide-right"
				src="/themes/rise-theme/dist/images/estate/character-view/henry/01_house_right.png" alt="">
		</div>
	</div>
</template>

<script>
import { store } from '../../store';

export default {
	data() {
		return {
			store,
			subtitlesUrl: {
				'en': '/themes/rise-theme/resources/assets/audio/henry/1.srt',
				'es': '/themes/rise-theme/resources/assets/audio/henry/1_es.srt'
			},
			subtitlesUrl2: {
				'en': '/themes/rise-theme/resources/assets/audio/henry/4.srt',
				'es': '/themes/rise-theme/resources/assets/audio/henry/4_es.srt'
			},
			autoStartClip: true,
			mutationObserver: null,
			slideOne: [
				{
					start: 9000,
					end: 10000,
					fromStyle: { transform: 'translateX(0px) rotateZ(0deg)' },
					toStyle: { transform: 'translateX(-30px) rotateZ(0deg)' },
					easing: 'linear'
				},
				{
					start: 9500,
					end: 10000,
					fromStyle: { transform: 'translateX(-30px) rotateZ(0deg)' },
					toStyle: { transform: 'translateX(-30px) rotateZ(-2deg)' },
					easing: 'linear'
				},
				{
					start: 17000,
					end: 18000,
					fromStyle: { transform: 'translateX(-30px) rotateZ(-2deg)' },
					toStyle: { transform: 'translateX(-30px) rotateZ(1deg)' },
					easing: 'linear'
				},
				{
					start: 20000,
					end: 21000,
					fromStyle: { transform: 'translateX(-30px) rotateZ(1deg)' },
					toStyle: { transform: 'translateX(-20px) rotateZ(-1deg)' },
					easing: 'linear'
				},
				{
					start: 21000,
					end: 22000,
					fromStyle: { transform: 'translateX(-20px) rotateZ(-1deg)' },
					toStyle: { transform: 'translateX(-4px) rotateZ(0deg)' },
					easing: 'linear'
				},
				{
					start: 23000,
					end: 25000,
					fromStyle: { transform: 'translateX(-4px) rotateZ(0deg)' },
					toStyle: { transform: 'translateX(0px) rotateZ(0deg)' },
					easing: 'linear'
				}
			],
			slideTwo: [
				{
					start: 9000,
					end: 10000,
					fromStyle: { transform: 'translateX(0px) rotateZ(0deg)' },
					toStyle: { transform: 'translateX(30px) rotateZ(0deg)' },
					easing: 'linear'
				},
				{
					start: 9500,
					end: 10000,
					fromStyle: { transform: 'translateX(30px) rotateZ(0deg)' },
					toStyle: { transform: 'translateX(30px) rotateZ(3deg)' },
					easing: 'linear'
				},
				{
					start: 13000,
					end: 14000,
					fromStyle: { transform: 'translateX(30px) rotateZ(3deg)' },
					toStyle: { transform: 'translateX(100px) rotateZ(5deg)' },
					easing: 'linear'
				},
				{
					start: 14500,
					end: 16500,
					fromStyle: { transform: 'translateX(100px) rotateZ(5deg)' },
					toStyle: { transform: 'translateX(400px) rotateZ(5deg)' },
					easing: 'linear'
				},
				{
					start: 17500,
					end: 17900,
					fromStyle: { transform: 'translateX(400px) rotateZ(5deg)' },
					toStyle: { transform: 'translateX(200px) rotateZ(3deg)' },
					easing: 'linear'
				},
				{
					start: 19000,
					end: 20000,
					fromStyle: { transform: 'translateX(200px) rotateZ(3deg)' },
					toStyle: { transform: 'translateX(20px) rotateZ(2deg)' },
					easing: 'linear'
				},
				{
					start: 20000,
					end: 25000,
					fromStyle: { transform: 'translateX(20px) rotateZ(2deg)' },
					toStyle: { transform: 'translateX(4px) rotateZ(0deg)' },
					easing: 'linear'
				},
				{
					start: 23000,
					end: 25000,
					fromStyle: { transform: 'translateX(4px) rotateZ(0deg)' },
					toStyle: { transform: 'translateX(0px) rotateZ(0deg)' },
					easing: 'linear'
				}
			]
		};
	},
	created() {
		this.$watch('$route.meta', (newVal) => {
			this.autoStartClip = !newVal.intro;
		}, { immediate: true });
		const unwatch = this.$watch('$tutorial.value', newVal => {
			this.autoStartClip = newVal;
			this.emitter.emit('auto-play');
			unwatch();
		});
		this.$watch('store.lang', newVal => {
			if (Object.values(this.subtitlesUrl).includes(this.$subtitlesUrl.value)) {
				this.$subtitlesUrl.value = this.subtitlesUrl[newVal]
			}
			if (Object.values(this.subtitlesUrl2).includes(this.$subtitlesUrl.value)) {
				this.$subtitlesUrl.value = this.subtitlesUrl2[newVal]
			}
		}, { immediate: true });
	},

	mounted() {
		const self = this;
		const audio = '/themes/rise-theme/resources/assets/audio/henry/1.mp3';
		const evidence = {
			items: [
				{
					image: '/themes/rise-theme/dist/images/estate/character-view/henry/evidence/1.jpg',
					url: 'https://history.coateslibrary.com/exhibits/show/exhibit/community/involvement/redlining',
					link_title: {
						'en': "Redlining: the Racist Policy that Shaped San Antonio's Urban Core",
						'es': 'Redlining: la política racista que dio forma al núcleo urbano de San Antonio'
					},
				}
			],
			text: {
				'en': '"The HOLC categorized neighborhoods with high populations of African American and Latino residents as “definitely declining” or “hazardous.” It then used these labels to deny home loans to people living in these communities. This policy intensified existing racial segregation and conditions of poverty as they prevented people of color from building wealth through homeownership..."',
				'es': '"El HOLC clasificó los vecindarios con una alta población de residentes afroamericanos y latinos como "definitivamente en declive" o "peligrosos". Luego usó estas etiquetas para negar préstamos hipotecarios a las personas que viven en estas comunidades. Esta política intensificó la segregación racial existente y las condiciones de pobreza, ya que impedían que las personas de color acumularan riqueza a través de la propiedad de vivienda..."'
			}
		};
		const text = {
			'en': "For many people of color in most American cities, buying a home of their own was a struggle due to the country's racist housing policies. Mortgages to Black families were often restricted, so just as Ronald's grandmother experienced, many had to find alternative financing and their homes were often segregated.",
			'es': 'Para muchas personas de color en la mayoría de las ciudades estadounidenses, comprar una casa propia fue una lucha debido a las políticas de vivienda racistas del país. Las hipotecas para las familias negras a menudo estaban restringidas, por lo que, tal como lo experimentó la abuela de Ronald, muchos tuvieron que encontrar financiamiento alternativo y sus hogares a menudo estaban segregados.'
		};

		this.$readMore.value = text;
		this.$audioUrl.value = audio;
		this.$subtitlesUrl.value = this.subtitlesUrl[this.store.lang];
		this.$evidence.value = JSON.stringify(evidence);

		self.emitter.on('player-ready', () => {
			console.log('player-ready event catch')
			setTimeout(() => {
				if (self.autoStartClip) {
					self.emitter.emit('auto-play');
				}
			}, 500);
		});

		this.mutationObserver = new window.MutationObserver(mutationList => {
			mutationList.forEach(mutation => {
				if (mutation.target.style.transform == 'translateX(200px) rotateZ(3deg)') {
					const evidence = {
						items: [
							{
								image: '/themes/rise-theme/dist/images/estate/character-view/henry/evidence/6.png',
								url: 'https://www.youtube.com/watch?v=iAIBzatbnBw',
								link_title: {
									'en': "Know Your Rights: Heir Property Owners",
									'es': 'Conozca sus derechos: herederos propietarios'
								},
							}
						],
						text: ''
					};
					const text = {
						'en': 'There are avenues to protect heirs property owners from investors and developers trying to profit off of family homes. Legal services are a good place to start to understand your rights.',
						'es': 'Existen vías para proteger a los propietarios de los herederos de los inversionistas y desarrolladores que intentan sacar provecho de las viviendas familiares. Los servicios legales son un buen lugar para comenzar a comprender sus derechos.'
					};
					const audio = '/themes/rise-theme/resources/assets/audio/henry/4.mp3';

					self.$evidence.value = JSON.stringify(evidence);
					self.$readMore.value = text;
					this.$audioUrl.value = audio;
					this.$subtitlesUrl.value = this.subtitlesUrl2[this.store.lang];
				}
			});
		});

		this.mutationObserver.observe(this.$refs.slideTwo, {
			attributes: true,
			attributeFilter: ['style']
		});

	},
	unmounted() {
		this.mutationObserver.disconnect();
	},
}
</script>

<style lang="scss" scoped>
.slide-house {
	position: relative;

	.slide-1 img {
		visibility: hidden;
	}

	.slide-2 {
		position: absolute;
		top: 0;
		left: 0;
		display: flex;
	}

	.slide-left {
		display: block;
		min-width: 545px;
		position: relative;
		top: -12px;
		left: 29px;
		transition: all 0.1s linear;
	}

	.slide-right {
		display: block;
		min-width: 500px;
		position: relative;
		top: -12px;
		right: 54px;
		transition: all 0.1s linear;
	}
}

@media screen and (max-width: 1680px) {
	.slide-house .slide-left {
		min-width: 580px;
		left: 2px;
	}

	.slide-house .slide-right {
		min-width: 524px;
		right: 79px;
	}
}

@media screen and (max-width: 1440px) {
	.slide-house .slide-left {
		min-width: 450px;
		left: 13px;
	}

	.slide-house .slide-right {
		min-width: 470px;
		right: 54px;
	}
}

@media screen and (max-width: 1280px) {
	.slide-house .slide-left {
		min-width: 292px;
		left: 25px;
	}

	.slide-house .slide-right {
		min-width: 321px;
		right: 20px;
	}
}

@media screen and (max-width: 650px) {
	.slide-house .slide-left {
		min-width: 160px;
		left: 7px;
		top: -6px;
	}

	.slide-house .slide-right {
		min-width: 160px;
		right: 17px;
		top: -6px;
	}
}
</style>
